import React from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.scss'
import Pages from './pages'
import { Provider } from 'react-redux'
import store from './state/store'
import { LoadScript } from '@react-google-maps/api'
import { Loader, AppErrorBoundary } from 'components'
import { preloadCriticalData } from './api'
import { initializeMigrationUtils } from './utils/googleMapsMigration'
import { initializeSecurity } from './utils/security'

const REACT_APP_GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY

// Initialize migration utilities with error handling
try {
  initializeMigrationUtils()
} catch (error) {
  console.warn('Failed to initialize migration utilities:', error)
}

// Initialize security features with conditional logic
// Now supports both browser and mobile app contexts
try {
  initializeSecurity()
} catch (error) {
  console.warn('Failed to initialize security:', error)
}


// Preload critical data with error handling
try {
  preloadCriticalData()
} catch (error) {
  console.warn('Failed to preload critical data:', error)
}

// Register service worker early so iOS/Android can treat the site as installable
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {})
  })
}

const root = createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <Provider store={store}>
        <LoadScript
          googleMapsApiKey={REACT_APP_GOOGLE_MAP_API_KEY}
          loadingElement={<Loader />}
        >
          <Pages />
        </LoadScript>
      </Provider>
    </AppErrorBoundary>
  </React.StrictMode>
)
